'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';

/**
 * Live state of the HM special (code) sale for client components that render
 * many products at once (category cards). One fetch per page load, shared by
 * every caller through a module-level promise, so a grid of 40 cards makes
 * one request, not 40.
 *
 * @param {boolean} enabled - false skips the fetch entirely
 * @returns {{ active: boolean, supplierIds: number[] }}
 */
let statePromise = null;
const fetchState = () => {
  if (!statePromise) {
    statePromise = fetch('/api/special-sale').then(res => res.json()).then(data => ({
      active: !!data?.active,
      supplierIds: Array.isArray(data?.supplier_ids) ? data.supplier_ids.map(Number) : []
    })).catch(() => {
      statePromise = null; // allow a retry on the next mount
      return {
        active: false,
        supplierIds: []
      };
    });
  }
  return statePromise;
};
const OFF = {
  active: false,
  supplierIds: []
};
export function useHmSpecialSale(t0) {
  const $ = _c(3);
  const enabled = t0 === undefined ? true : t0;
  const [state, setState] = useState(OFF);
  let t1;
  let t2;
  if ($[0] !== enabled) {
    t1 = () => {
      if (!enabled) {
        return;
      }
      let cancelled = false;
      fetchState().then(s => {
        if (!cancelled) {
          setState(s);
        }
      });
      return () => {
        cancelled = true;
      };
    };
    t2 = [enabled];
    $[0] = enabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return state;
}

/**
 * Does this product get the special-sale line? Same rule as the product page:
 * switch on, MillerKnoll supplier, flagged on_sale.
 */
export function isHmSpecialSaleProduct(product, state) {
  return !!state?.active && product?.on_sale == 1 && state.supplierIds.includes(Number(product.supplier_id));
}